(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["model-viewer"] && !Shopify.designMode) return;
  try {
    
var viewer;
var load = function(e) {
    if (e) {
        console.log('model viewer load: ', e.detail);
    }
    var mountEl = document.getElementById('coohom-model-viewer');
    var {
        modelid, locale, hidelogo, hidesharebutton
    } = mountEl.dataset;
    viewer = new koolViewer.ViewerUISDK({
        mount: mountEl,
        modelId: modelid,
        locale: locale,
        enableDisplayLogo: hidelogo === 'No',
        enableShareIcon: hidesharebutton === 'No'
    });
};
var unload = function(e) {
    if (e) {
        console.log('model viewer unload: ', e.detail);
    }
    if (viewer) {
        viewer.destroy();
    }
}
if (Shopify.designMode) {
    document.addEventListener("shopify:section:load", load);
    document.addEventListener("shopify:section:unload", unload);
}
load();

  } catch(e) { console.error(e); }
})();
})();
